export type PartInfo = { name: string; size: number; mtime: number };

export async function listParts(): Promise<PartInfo[]> {
  const r = await fetch("/api/parts");
  if (!r.ok) throw new Error(`list failed: ${r.status}`);
  return r.json();
}

export async function uploadPart(file: File): Promise<PartInfo> {
  const fd = new FormData();
  fd.append("file", file);
  const r = await fetch("/api/parts", { method: "POST", body: fd });
  if (!r.ok) {
    const body = await r.json().catch(() => ({ error: r.statusText }));
    throw new Error(body.error ?? `upload failed: ${r.status}`);
  }
  return r.json();
}

export async function deletePart(name: string): Promise<void> {
  const r = await fetch(`/api/parts/${encodeURIComponent(name)}`, { method: "DELETE" });
  if (!r.ok && r.status !== 404) throw new Error(`delete failed: ${r.status}`);
}

export function partUrl(name: string): string {
  return `/api/parts/${encodeURIComponent(name)}`;
}
